import moment from "moment";

export class RosterPlan {
  RosterPlanCode;
  PlanDesc;
  Shift1;
  Shift2;
  Shift3;
  Shift4;
  Shift5;
  Shift6;
  Shift7;
  HolidayType;
  constructor() {
    this.RosterPlanCode = "";
    this.PlanDesc = "";
    this.Shift1 = "";
    this.Shift2 = "";
    this.Shift3 = "";
    this.Shift4 = "";
    this.Shift5 = "";
    this.Shift6 = "";
    this.Shift7 = "";
    this.HolidayType = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/RosterPlan.js